import ToastService from '~/services/toast.service';

import { clone } from '@vestigas/utils';
import { log } from '~/utils/logging';

/**
 * Updates the name of a filter group in the given filterGroups array.
 *
 * @param {string} filterGroupId - The ID of the filter group to update.
 * @param {string} filterGroupName - The new name for the filter group.
 * @param {array} filterGroups - The array of filter groups to update.
 * @param {function} setDelivery_filterGroups - Callback function to set the updated filter groups.
 * @param {function} updateUserSettings - The function to update filter groups on back-end.
 * @return {void}
 */
export const updateFilterGroupName = async (
  dispatch,
  filterGroupId,
  filterGroupName,
  filterGroups,
  setDelivery_filterGroups,
  updateUserSettings,
) => {
  const newFilterGroups = clone(filterGroups);

  for (const filterGroup of newFilterGroups) {
    if (filterGroup.id === filterGroupId) {
      filterGroup.name = filterGroupName;
    }
  }

  await updateUserSettings(
    { webappDeliveryFilterGroups: newFilterGroups },
    {
      onError(error) {
        log.error({ message: 'Failed to update filter group name.', error });
        ToastService.error(['Filter konnte nicht umbenannt werden.']);
        throw error; // Re-throw error to be caught by calling function
      },
    },
  );

  dispatch(setDelivery_filterGroups(newFilterGroups));
};
